var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"ring-group-icon-container"},[(_vm.tooltip)?_c('el-tooltip',{attrs:{"placement":"top","effect":"dark","content":_vm.type === 'team' ? _vm.CONNECTED_INBOX_NAME : _vm.PERSONAL_INBOX_NAME}},[_c('img',_vm._b({},'img',_vm.imgProps,false))]):_c('img',_vm._b({},'img',_vm.imgProps,false))],1)
}
var staticRenderFns = []

export { render, staticRenderFns }